import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "shared/constants/routes";
import { fetchDtfOrders } from "actions/dtfOrders";
import OrderCard from "./OrderCard";
import {
  Container,
  PageHeader,
  PageTitle,
  PageSubtitle,
  OrdersList,
  EmptyState,
  EmptyTitle,
  EmptyText,
  LoadingState,
  LoadingDots,
} from "styles/pages/dtf-transfers/orders";

const DtfOrders = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const token = useSelector((state) => state?.auth?.profile?.token);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOrders = async () => {
      if (!emailid) {
        setOrders([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      const response = await dispatch(fetchDtfOrders(emailid, token));

      if (response?.error) {
        setOrders([]);
      } else {
        setOrders(response);
      }

      setLoading(false);
    };

    if (location.pathname === ROUTES.DTF_ORDERS.LINK) {
      loadOrders();
    }
  }, [dispatch, emailid, token, location.pathname]);

  return (
    <Container>
      <PageHeader>
        <PageTitle>{ROUTES.DTF_ORDERS.TITLE}</PageTitle>
        <PageSubtitle>VIEW YOUR DTF TRANSFER ORDERS</PageSubtitle>
      </PageHeader>

      {loading ? (
        <LoadingState>
          <LoadingDots aria-hidden>
            <span />
            <span />
            <span />
          </LoadingDots>
          <EmptyTitle>Loading orders...</EmptyTitle>
        </LoadingState>
      ) : orders.length === 0 ? (
        <EmptyState>
          <EmptyTitle>No orders yet</EmptyTitle>
          <EmptyText>
            Your DTF transfer orders will appear here after checkout.{" "}
            <Link to={ROUTES.DTF_TRANSFERS_BY_SIZE.LINK}>
              Start designing transfers
            </Link>
          </EmptyText>
        </EmptyState>
      ) : (
        <OrdersList>
          {orders.map((order, index) => (
            <OrderCard
              key={order?._id ?? order?.orderId ?? order?.id ?? index}
              order={order}
            />
          ))}
        </OrdersList>
      )}
    </Container>
  );
};

export default DtfOrders;
